import { render, staticRenderFns } from "./Inserter.vue?vue&type=template&id=60f83139"
import script from "./Inserter.vue?vue&type=script&lang=js"
export * from "./Inserter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports